import React from 'react';
import _ from 'underscore';

type IRadioOnChangeHandler = React.ChangeEventHandler<HTMLInputElement>;

type Props = {
  checked?: boolean;
  disabled?: boolean;
  children?: React.ReactElement | string;
  className?: string;
  id?: string;
  name?: string;
  onChange: IRadioOnChangeHandler;
  value: string;
};

export function Radio(props: Props) {
  const id = props.id ? props.id : _.uniqueId('radio-');

  return (
    <div
      className={props.className}
      data-checked={props.checked}
    >
      <label htmlFor={id}>
        <input
          type="radio"
          name={props.name}
          id={id}
          value={props.value}
          checked={props.checked}
          disabled={props.disabled}
          onChange={props.onChange}
          aria-checked={props.checked}
          aria-disabled={props.disabled}
        />
        {props.children}
      </label>
    </div>
  );
}

Radio.defaultProps = {
  checked: false,
  disabled: false,
  children: null,
  className: 'radio',
  id: null,
  name: null,
};
